export const convertPreselectedIdToPackageId = (
	preSelectedPackageId: string | null,
): string | null => {
	switch (preSelectedPackageId) {
		case "foretagarna":
			return "FÖRETAGARNA-BAS";
		case "foretagarna-kreditkort":
			return "FORETAGARNA-CARDONLY";
		case "vaxa":
			return "BAAS-FÖRETAG-VÄXA";
		case "bas":
			return "BAAS-FÖRETAG-BAS";
		case "e-handel":
			return "E-HANDEL-BAS";
		// TODO: remove checkkredit (and maybe kontokredit) case once aligned from svea.com
		case "finansiera":
		case "checkkredit":
		case "kontokredit":
			return "OVERDRAFTPACKAGE";

		default:
			return preSelectedPackageId;
	}
};
